import { atom, useAtom } from 'jotai';
import {IntentEnum} from "../enums/IntentEnum";

// array for the chat windows
const tabs = [
  {
    id: '0',
    radio: 'radio-1',
    intent: IntentEnum.SendQuestion,
    label: 'Compare',
    icon: 'database'
  },
  {
    id: '1',
    radio: 'radio-2',
    intent: IntentEnum.FreeQuestion,
    label: 'Question',
    icon: 'description'
  }
];
export const tabsAtom = atom(tabs);

export function useTabsAtom() {
  return useAtom(tabsAtom);
}
